import { useMemo } from 'react'

type UseUnlinkSalesforceOpportunityModal = (props: {
  onConfirm: () => void
}) => {
  submit: {
    onClick: () => boolean
  }
}

/**
 * This hook powers the unlink customer modal. The modal itself is designed to
 * be used in any situation, and therefore packs its own data loading capabilities.
 * As of the point of implementation, we expect to be using this modal in
 * the context of the 'Inspector' present in Quote and Customer screens as well
 * as a kebab menu item in the customer list.
 *
 * @param props
 * @returns
 */
export const useUnlinkSalesforceOpportunityModal: UseUnlinkSalesforceOpportunityModal =
  props => {
    const submit = useMemo(() => {
      return {
        onClick: (): boolean => {
          props.onConfirm?.()
          return true
        }
      }
    }, [props])

    return {
      submit
    }
  }
